import { MarketPlacesEnum } from "@/types/types";
import { MARKET_PLACE_ICON_BY_TYPE, MarketPlace } from "@/types/market-place";

export const getLinkToWbProduct = (
  id: string | number,
  sizeId?: number | null | undefined,
) => {
  return `https://www.wildberries.ru/catalog/${id}/detail.aspx${sizeId ? `?size=${sizeId}` : ""}`;
};

export const getLinkToOzonProduct = (id: string | number) => {
  return `https://www.ozon.ru/product/${id}`;
};

export const getLinks = (payload: {
  ozonArticle?: string | number | null;
  wbArticle?: string | number | null;
  wbSiseId?: number | null;
  chZnLink?: string | null;
}) => {
  const links = [];
  if (payload.wbArticle) {
    links.push({
      link: getLinkToWbProduct(payload.wbArticle, payload.wbSiseId),
      market: MarketPlacesEnum.wildberries,
      marketPlace: MarketPlace.Wildberries,
      icon: MARKET_PLACE_ICON_BY_TYPE[MarketPlace.Wildberries],
    });
  }
  if (payload.ozonArticle) {
    links.push({
      link: getLinkToOzonProduct(payload.ozonArticle),
      market: MarketPlacesEnum.ozon,
      marketPlace: MarketPlace.Ozon,
      icon: MARKET_PLACE_ICON_BY_TYPE[MarketPlace.Ozon],
    });
  }
  if (payload.chZnLink) {
    links.push({
      link: payload.chZnLink,
      market: MarketPlacesEnum.chestniyZnak,
      marketPlace: MarketPlace.ChestniyZnak,
      icon: MARKET_PLACE_ICON_BY_TYPE[MarketPlace.ChestniyZnak],
    });
  }

  return links;
};
